"use client";
import {
  __spreadValues
} from "../../chunk-MMUBH76A.js";
var EvmWallet = /* @__PURE__ */ ((EvmWallet2) => {
  EvmWallet2["METAMASK"] = "METAMASK";
  EvmWallet2["RAINBOW"] = "RAINBOW";
  EvmWallet2["COINBASE"] = "COINBASE";
  EvmWallet2["WALLETCONNECT"] = "WALLETCONNECT";
  EvmWallet2["ZERION"] = "ZERION";
  EvmWallet2["SAFE"] = "SAFE";
  EvmWallet2["RABBY"] = "RABBY";
  EvmWallet2["OKX"] = "OKX";
  return EvmWallet2;
})(EvmWallet || {});
var SolanaWallet = /* @__PURE__ */ ((SolanaWallet2) => {
  SolanaWallet2["PHANTOM"] = "PHANTOM";
  SolanaWallet2["GLOW"] = "GLOW";
  SolanaWallet2["BACKPACK"] = "BACKPACK";
  return SolanaWallet2;
})(SolanaWallet || {});
var CosmosWallet = /* @__PURE__ */ ((CosmosWallet2) => {
  CosmosWallet2["KEPLR"] = "KEPLR";
  CosmosWallet2["LEAP"] = "LEAP";
  return CosmosWallet2;
})(CosmosWallet || {});
const ExternalWallet = __spreadValues(__spreadValues(__spreadValues({}, EvmWallet), SolanaWallet), CosmosWallet);
export {
  CosmosWallet,
  EvmWallet,
  ExternalWallet,
  SolanaWallet
};
